import { render, staticRenderFns } from "./FlatCard.vue?vue&type=template&id=aca86592"
import script from "./FlatCard.vue?vue&type=script&lang=js"
export * from "./FlatCard.vue?vue&type=script&lang=js"
import style0 from "./FlatCard.vue?vue&type=style&index=0&id=aca86592&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports